const PREFIX = 'UnoCaptcha/';
export const ACTION_TYPE_SHOW_JCAPTCHA = PREFIX + 'SHOW_JCAPTCHA';
export const ACTION_TYPE_HIDE_JCAPTCHA = PREFIX + 'HIDE_JCAPTCHA';
export const ACTION_TYPE_REFRESH_JCAPTCHA = PREFIX  + 'REFRESH_JCAPTCHA';


export const showJcaptcha = (unoCaptchaName) => ({
    type: ACTION_TYPE_SHOW_JCAPTCHA,
    unoCaptchaName
});

export const hideJcaptcha = (unoCaptchaName) => ({
    type: ACTION_TYPE_HIDE_JCAPTCHA,
    unoCaptchaName
});

export const refreshJcaptcha = (unoCaptchaName) => ({
    type: ACTION_TYPE_REFRESH_JCAPTCHA,
    unoCaptchaName
});
